import { VelavuRuleAction, VelavuRuleDeviceConfig } from "velavu-js-api";
import NormalizedRuleEventOptions, {
	velavuEventOptionsToNormalizedRuleEventOptions,
	normalizedRuleEventOptionsToVelavuEventOptions,
} from "./normalized-rule-event-options";

export default interface NormalizedRuleAction {
	config: VelavuRuleDeviceConfig | null;
	activationEvent: NormalizedRuleEventOptions | null;
	deactivationEvent: NormalizedRuleEventOptions | null;
}

export function normalizedRuleActionIsEmpty(
	action: NormalizedRuleAction,
): boolean {
	return (
		action.activationEvent === null &&
		action.deactivationEvent === null &&
		action.config === null
	);
}

export function ruleActionToNormalizedRuleAction(
	rule: VelavuRuleAction,
): NormalizedRuleAction {
	return {
		config: rule.config ?? null,
		activationEvent: velavuEventOptionsToNormalizedRuleEventOptions(
			rule.on_active,
		),
		deactivationEvent: velavuEventOptionsToNormalizedRuleEventOptions(
			rule.on_deactive,
		),
	};
}

export function normalizedRuleActionToRuleAction(
	state: NormalizedRuleAction,
): VelavuRuleAction {
	return {
		config: state.config ?? undefined,
		on_active: normalizedRuleEventOptionsToVelavuEventOptions(
			state.activationEvent,
		),
		on_deactive: normalizedRuleEventOptionsToVelavuEventOptions(
			state.deactivationEvent,
		),
	};
}
